module.exports = __webpack_public_path__ + "img/IT0000178909225.36225490.png";